module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt2.f32442e743d3ee22bf4656d4b5cca5ea.png";